import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckboxAnswer from '../../Answer/CheckboxAnswer';

import styles from './styles.module.scss';

const CheckboxQuestion = ({ number, stage, question, activeQuestion, setSelectedAnswer, disabled }) => {
  const { t } = useTranslation();

  return <div className={styles.question + ' ' + (question.answer ? styles.complete : disabled ? styles.disabled : '') + ' ' + (number === activeQuestion ? styles.active : '')}>
    <h3 className={styles.title}>
      {t(`tool_ui.${stage.key}.${question.key}`)}
    </h3>
    <p className={styles.extra}>
      {t(`tool_ui.${stage.key}.${question.key}_extra`)}
    </p>
    <div className={styles.answers}>
      {question.choices.map((answer, index) => <CheckboxAnswer
        key={index}
        question={question}
        item={answer}
        setSelectedAnswer={setSelectedAnswer}
        disabled={disabled}
      />)}
    </div>
  </div>;
}

export default CheckboxQuestion;
